/**
 * SSR-safe utilities for server-side rendering compatibility
 */

export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};

export const getPathname = (): string => {
  return isBrowser() ? window.location.pathname : '/';
};

export const getWindowDimensions = () => {
  if (!isBrowser()) {
    // Default to desktop breakpoint (lg: 1024px) for SSR
    // This prevents mobile layout flash on desktop devices
    return { width: 1024, height: 768 };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};
